import SocialShell from '@/components/social/SocialShell';
import { teacherTheme } from '@/components/social/themes';

export default function TeacherCorner() {
  return <SocialShell clubId="teachers-corner" theme={teacherTheme} canPost />;
}
